import React from "react";
import { Home, Heart, Users, Activity, Briefcase } from "lucide-react";

const PILLARS = [
    { label: "Your Home", icon: Home, testId: "pillar-home" },
    { label: "Your Life", icon: Heart, testId: "pillar-life" },
    { label: "Your Family", icon: Users, testId: "pillar-family" },
    { label: "Your Health", icon: Activity, testId: "pillar-health" },
    { label: "Your Business", icon: Briefcase, testId: "pillar-business" },
];

export default function TrustPillars() {
    return (
        <section
            data-testid="trust-pillars"
            className="relative border-y border-[rgba(212,175,55,0.15)] bg-[#05070a] py-14 md:py-20"
        >
            <div className="mx-auto max-w-[1400px] px-6 md:px-10">
                <div className="mb-10 flex items-end justify-between gap-8">
                    <div>
                        <p className="text-xs uppercase tracking-[0.4em] text-brand-goldSoft">
                            Lines We Quote
                        </p>
                        <h3 className="mt-3 font-serif text-3xl text-brand-ivory sm:text-4xl md:text-5xl">
                            Coverage <span className="gold-text">tailored</span>
                            <span className="text-brand-ivory">
                                {" "}
                                to your needs.
                            </span>
                        </h3>
                        <p className="mt-4 max-w-xl text-sm text-brand-muted">
                            Coverage options are subject to policy terms,
                            limits, deductibles, exclusions, underwriting, and
                            carrier availability.
                        </p>
                    </div>
                    <div className="gold-hairline hidden h-px w-40 md:block" />
                </div>

                <div className="grid grid-cols-2 gap-5 md:grid-cols-5 md:gap-6">
                    {PILLARS.map(({ label, icon: Icon, testId }, i) => (
                        <div
                            key={label}
                            data-testid={testId}
                            className="shield-card group relative overflow-hidden rounded-2xl border border-[rgba(212,175,55,0.2)] bg-[#0b0e13] p-6 text-center"
                            style={{ animationDelay: `${i * 80}ms` }}
                        >
                            <div className="shield-glow mx-auto mb-4 flex h-16 w-16 items-center justify-center">
                                <ShieldIcon>
                                    <Icon className="h-6 w-6 text-brand-gold2" />
                                </ShieldIcon>
                            </div>
                            <p className="text-[10px] uppercase tracking-[0.35em] text-brand-goldSoft">
                                Protect
                            </p>
                            <p className="mt-1 font-serif text-xl text-brand-ivory">
                                {label}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

function ShieldIcon({ children }) {
    return (
        <div className="relative">
            <svg
                viewBox="0 0 64 76"
                width="62"
                height="72"
                xmlns="http://www.w3.org/2000/svg"
            >
                <defs>
                    <linearGradient
                        id="pillar-gold"
                        x1="0"
                        x2="0"
                        y1="0"
                        y2="1"
                    >
                        <stop offset="0%" stopColor="#f3d77b" />
                        <stop offset="55%" stopColor="#d4af37" />
                        <stop offset="100%" stopColor="#8c6a1c" />
                    </linearGradient>
                </defs>
                <path
                    d="M32 3 L60 11 V40 C60 57 47 70 32 74 C17 70 4 57 4 40 V11 Z"
                    fill="#07090c"
                    stroke="url(#pillar-gold)"
                    strokeWidth="1.8"
                />
            </svg>
            <div className="absolute inset-0 flex items-center justify-center">
                {children}
            </div>
        </div>
    );
}
